import { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Row, Typography, Button, Checkbox } from "antd";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import moment from "moment";

import BackButton from "components/BackButton";
import { TextInput, TextEditor } from "components/common";
import { createSystemNotificationRequest } from "providers/SystemNotificationProvider/slice";
import Helper from "utils/helpers";
import "./styles.less";

const validationSchema = Yup.object().shape({
  title: Yup.string().required("Tiêu đề là bắt buộc"),
  message: Yup.string().required("Nội dung là bắt buộc"),
});

const SystemNotificationCreate = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const formikRef = useRef(null);
  const isLoading = useSelector((state) => 
    state.systemNotification.isLoading
  );

  const handleSubmit = async (values) => {
             const notificationData = {
           type: "systemNotification",
           title: values.title,
           description: values.message, // Changed from 'message' to 'description'
           targetUsers: "all",
           priority: "normal",
           sendToAllDevices: values.sendToAllDevices,
         };

    try {
      await dispatch(createSystemNotificationRequest(notificationData));
      Helper.toastr(
        "Tạo thông báo thành công",
        "Thông báo hệ thống đã được tạo thành công",
        "success"
      );
      navigate("/system_notifications", {
        state: { canGoBack: true },
        replace: true,
      });
    } catch (error) {
      console.error("Create notification error:", error);
      Helper.toastr(
        "Tạo thông báo thất bại",
        "Có lỗi xảy ra khi tạo thông báo. Vui lòng thử lại.",
        "error"
      );
    }
  };

  const initialValues = {
    title: "",
    message: "",
    sendToAllDevices: false,
  };

  return (
    <div className="system-notification-create-page">
      <Row className="system-notification-create-header">
        <Row>
          <BackButton />
          <Typography.Title level={4}>Tạo thông báo hệ thống</Typography.Title>
        </Row>
      </Row>
      <div className="create-form-wrapper">
        <Formik
          innerRef={formikRef}
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ handleSubmit: formikHandleSubmit, values, setFieldValue }) => (
            <Form>
              <div className="form-section">
                <div className="section-title">Thông tin thông báo</div>
                
                <div className="form-row">
                  <div className="form-item">
                    <div className="item-title">Tiêu đề:</div>
                    <TextInput 
                      name="title" 
                      size="large" 
                      required 
                      placeholder="Nhập tiêu đề thông báo"
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-item">
                    <div className="item-title">Nội dung:</div>
                    <TextEditor
                      name="message"
                      placeholder="Nhập nội dung thông báo..."
                      required
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-item">
                    <Checkbox
                      name="sendToAllDevices"
                      checked={values.sendToAllDevices}
                      onChange={(e) => setFieldValue("sendToAllDevices", e.target.checked)}
                    >
                      Gửi đến tất cả devices (kể cả chưa đăng nhập)
                    </Checkbox>
                  </div>
                </div>
              </div>
              
              <div className="form-actions">
                <Button
                  loading={isLoading}
                  size="large"
                  type="primary"
                  onClick={() => formikRef.current?.handleSubmit()}
                >
                  Tạo thông báo
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default SystemNotificationCreate; 